(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/result-interval.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/result-interval.js');

'use strict';

const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  selectedSpanResultsAtom = _svs$lyckoplatsen$com.selectedSpanResultsAtom,
  overlayResultAtom = _svs$lyckoplatsen$com.overlayResultAtom;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_result.react.components,
  MapInterval = _svs$lyckoplatsen$com2.MapInterval,
  Overlay = _svs$lyckoplatsen$com2.Overlay,
  WinAmountInterval = _svs$lyckoplatsen$com2.WinAmountInterval;
const ResultInterval = () => {
  const spanResults = useAtomValue(selectedSpanResultsAtom);
  const result = useAtomValue(overlayResultAtom);
  const hasSelectedResult = Boolean(result);
  return React.createElement("div", {
    className: "lp-page-result"
  }, React.createElement(MapInterval, {
    results: spanResults.results
  }), React.createElement(WinAmountInterval, null), React.createElement("div", {
    className: "u-text-center f-600 f-bold margin-2 margin-top-1"
  }, React.createElement("p", null, "Klicka p\xE5 en av lyckoplatserna som vunnit toppvinsten - f\xF6r att se vinstcirklarna och mer information om dragningen.")), hasSelectedResult && React.createElement(Overlay, null));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  ResultInterval
});

 })(window);